import { openExternalUrl } from '~/core/util/url';
import { analyticsTrackEvent } from '~/core/analytics';
import { CONTACT_US_NAVIGATION } from '~/core/analytics/events';
import { HELP_BASE_URL } from '../../../../../config';

export const useGoToContactUs = () => {
  return () => {
    analyticsTrackEvent(CONTACT_US_NAVIGATION, {});
    openExternalUrl(HELP_BASE_URL);
  };
};
